export class AutocompleteItem {
  [x: string]: any;
  public id: number | string;
  public title: string;
  public subtitle?: string;
  public hasSpecialty?: boolean;
  public imageUrl?: string;
}
